import { KitButton } from '@omni/kit/components';
import React, { ReactElement } from 'react';

//******************************************************************************
// Types
//******************************************************************************

export interface NavNextButtonProps {
  onPress: () => void;
}

export default function NavNextButton({
  onPress,
}: NavNextButtonProps): ReactElement {
  return <KitButton title='Add' onPress={onPress} />;
}
